import { Suspense } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { routes } from "./router";
import Spinner from "./components/Spinner";
import "@assets/css/App.css";

import DeploymentPopup from "@components/DeploymentPopup";

function AppRoutes() {
    return useRoutes(routes);
}

export default function App() {
    const isStage = import.meta.env.VITE_APP_ENV === "Development Environment";

    return (
        <BrowserRouter>
            {isStage && <DeploymentPopup />}
            <Suspense
                fallback={
                    <div className="flex items-center justify-center fixed inset-0 z-50 bg-primary-10">
                        <Spinner size="lg" variant="primary" />
                    </div>
                }
            >
                <AppRoutes />
            </Suspense>
        </BrowserRouter>
    );
}